<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
// Template SFC — PRESENTATION ONLY (DEV-1135 template purity contract:
// a single defineProps call, no imports, no other statements).
defineProps<{
  quiz: {
    logo?: string;
    title?: string;
    sub_title?: string;
    legal_name?: string;
    legal_id?: string;
    disclaimer?: string;
    privacy_url?: string;
    privacy_text?: string;
  };
  progress: { current: number; total: number };
  canGoBack: boolean;
  showHero: boolean;
  isGate: boolean;
}>();
</script>

<template>
  <div class="tpl-utua">
    <header class="tpl-utua__header">
      <img v-if="quiz.logo" :src="quiz.logo" alt="logo" class="tpl-utua__logo" />
    </header>

    <main class="tpl-utua__main">
      <div v-if="showHero" class="tpl-utua__hero">
        <h1 class="tpl-utua__hero-title">{{ quiz.title }}</h1>
        <p v-if="quiz.sub_title" class="tpl-utua__hero-sub">{{ quiz.sub_title }}</p>
      </div>

      <div v-if="!isGate" class="tpl-utua__progress">
        <button
          type="button"
          class="tpl-utua__nav-arrow"
          :class="{ 'tpl-utua__nav-arrow--disabled': !canGoBack }"
          :disabled="!canGoBack"
          aria-label="Voltar"
          @click="$emit('back')"
        >
          &#8249;
        </button>
        <div class="tpl-utua__progress-track">
          <div
            class="tpl-utua__progress-fill"
            :style="{ width: (progress.total ? (progress.current / progress.total) * 100 : 0) + '%' }"
          ></div>
        </div>
        <span class="tpl-utua__nav-arrow tpl-utua__nav-arrow--disabled">&#8250;</span>
      </div>
      <p v-if="!isGate" class="tpl-utua__progress-label">
        {{ progress.current }} - {{ progress.total }}
      </p>

      <slot />
    </main>

    <footer class="tpl-utua__footer">
      <div class="tpl-utua__footer-links">
        <a v-if="quiz.privacy_url" :href="quiz.privacy_url" target="_blank">
          {{ quiz.privacy_text || 'Privacy Policy' }}
        </a>
      </div>
      <p v-if="quiz.legal_name" class="tpl-utua__footer-legal">
        {{ quiz.legal_name }}<template v-if="quiz.legal_id"> — {{ quiz.legal_id }}</template>
      </p>
      <p v-if="quiz.disclaimer" class="tpl-utua__footer-disclaimer">{{ quiz.disclaimer }}</p>
    </footer>
  </div>
</template>
